// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pt-overlay[data-v-346aa522]{position:fixed;overflow-y:scroll;top:0;right:0;bottom:0;left:0;background:rgba(0,0,0,.5);z-index:100}", ""]);
// Exports
module.exports = exports;
